import { DialogProps } from '@material-ui/core';
import { useCacheContext } from 'framework/hooks/useCacheContext';
import { IPatient, patientsCommand_updateLabels } from 'gen/ApiClient';
import React from 'react';
import { LabelsForm } from 'shared/LabelsForm';
import { PatientsFilterDataContext } from '../PatientsFilterDataContext';

interface IProps extends DialogProps {
	item: IPatient;
	cancel: VoidFunction;
	confirm: VoidFunction;
}

export const PatientLabelsForm = ({ item, ...rest }: IProps) => {
	const [data] = useCacheContext(PatientsFilterDataContext);

	if (data === undefined) {
		return <div></div>;
	}

	return (
		<LabelsForm
			{...rest}
			autoCompleteLabels={data.labels}
			labels={item.labels}
			updateF={values => patientsCommand_updateLabels(item.id, values)}
		/>
	);
};
